module.exports = __webpack_public_path__ + "img/Img14b_204737_DgDq-1-60-1.e5cdab8f.jpg";